import type { MarketInterval, MarketRange } from '../types/market';

export const INTERVAL_OPTIONS: Array<{ interval: MarketInterval; range: MarketRange; label: string }> = [
  { interval: '1m', range: '7d', label: '1m' },
  { interval: '5m', range: '60d', label: '5m' },
  { interval: '15m', range: '60d', label: '15m' },
  { interval: '1h', range: '730d', label: '1H' },
  { interval: '1d', range: '5y', label: '1D' },
  { interval: '1wk', range: '5y', label: '1W' },
  { interval: '1mo', range: '10y', label: '1M' }
];
